<template>
  <div>
    <!--聊天信息总汇  -->
    <baseBreadcrumb :page="$t('message.chatSummary')" :menu="$t('message.operationAndMaintenance')" />
    <div class="body" v-if="type == 'chatSummary'">
      <div class="tabs">
        <el-tabs v-model="datas.statusName" type="card" @tab-click="setScoreStatus('')">
          <!-- 全部 -->
          <el-tab-pane :label="`${$t('message.all')} `" name="全部"></el-tab-pane>
          <!-- 待内部处理 -->
          <el-tab-pane :label="`${$t('message.pendingInternalProcessing')} (${tabsNum[0].num})`"
            name="待内部处理"></el-tab-pane>
          <!--待日本审核  -->
          <el-tab-pane :label="`${$t('message.pendingJapanReview')} (${tabsNum[1].num})`" name="待日本审核"></el-tab-pane>
          <!-- 待部长确认 -->
          <el-tab-pane :label="`${$t('message.pendingMinisterConfirmation')} (${tabsNum[2].num})`"
            name="待部长确认"></el-tab-pane>
          <!-- 最终复核 -->
          <el-tab-pane :label="`${$t('message.finalReview')} (${tabsNum[3].num})`" name="最终复核"></el-tab-pane>
          <!-- 已完成 -->
          <el-tab-pane :label="$t('message.accomplish')" name="已完成"></el-tab-pane>
        </el-tabs>
        <div class="btn" v-if="datas.statusName == '已完成'">
          <el-button :type="datas.score_status == 1 ? 'primary' : ''" @click="setScoreStatus(1)">待评分（{{ tabsNum[4].num
          }}）</el-button>
          <el-button :type="datas.score_status == 2 ? 'primary' : ''" @click="setScoreStatus(2)">已评分</el-button>
        </div>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <div class="item">
          <el-input v-model="datas.user_id" :placeholder="$t('message.userID')"></el-input>
        </div>
        <div class="item">
          <el-select v-model="datas.chatType" clearable>
            <el-option v-for="item in chatType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="item " v-if="datas.statusName != '待部长确认'">
          <el-select v-model="datas.status" clearable placeholder="是否是投诉筛选">
            <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="item " v-if="datas.statusName == '已完成'">
          <el-select v-model="datas.complaint_type" clearable placeholder="投诉类别筛选">
            <el-option v-for="item in complaintType" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="item ">
          <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
            <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 是否纳入考核 -->
        <div class="item ">
          <el-select v-model="datas.performance_status" clearable filterable
            :placeholder="$t('message.whetherIncludedInAssessment')">
            <el-option :label="$t('message.are')" :value="1">
            </el-option>
            <el-option :label="$t('message.no')" :value="2">
            </el-option>
          </el-select>
        </div>
        <!-- 是否经过复核 -->
        <div class="item " v-if="datas.statusName == '已完成'">
          <el-select v-model="datas.is_depart_review" clearable filterable :placeholder="$t('message.whetherReviewed')">
            <el-option :label="$t('message.are')" :value="1">
            </el-option>
            <el-option :label="$t('message.no')" :value="2">
            </el-option>
          </el-select>
        </div>
        <!-- 搜索 -->
        <el-button type="primary" @click="search">
          {{ $t('message.search') }}
        </el-button>
        <div class="btn">
          <!-- 批量审核 -->
          <el-button type="primary" @click="batchReviewProcess" v-if="datas.statusName == '待部长确认'">
            {{ $t('message.batchReviewProcess') }}
          </el-button>
          <!-- 批量确认 -->
          <el-button type="primary" @click="BatchConfirmation" v-if="datas.statusName == '最终复核'">
            {{ $t('message.BatchConfirmation') }}
          </el-button>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table" v-if="datas.statusName == '全部'">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" border v-if="isShow"
          :max-height="tableautoheight" @selection-change="handleSelectionChange">
          <!-- 客户信息 -->
          <el-table-column align="center" :label="$t('message.userInfo')" prop="send_realname" width="120">
            <template slot-scope="scope">
              <p>ID:{{ scope.row.format.user_id }}</p>
              <p>{{ scope.row.format.user_realname }}</p>
              <p>
                <attributeName :name="scope.row.format.user_attribute" />
              </p>
            </template>
          </el-table-column>
          <!-- 对应人员 -->
          <el-table-column align="center" :label="$t('message.correspondingPersonnel')" prop="send_realname"
            width="120">
            <template slot-scope="scope">
              <!-- 业务：XXX -->
              <p> {{ $t('message.business') }}:
                {{ scope.row.format.y_realname }}</p>
              <!-- 采购：XXX-->
              <p> {{ $t('message.purchase') }}:{{ scope.row.format.g_realname }}</p>
              <!-- 配货：XXX -->
              <p> {{ $t('message.distribution') }}:{{ scope.row.format.p_realname }}</p>
            </template>
          </el-table-column>
          <!-- 发送对象 -->
          <el-table-column align="center" prop="send_realname" width="160">
            <template slot-scope="scope">
              <p v-if="scope.row.format.chat_type == 'CW'"> <img src="@/assets/icon/chatword.png" alt=""
                  style="width: 40px; vertical-align: middle;">CHATWORK</p>
              <p v-else> <img src="@/assets/icon/Rakuchat.png" alt=""
                  style="width: 40px; vertical-align: middle;">RAKUCHAT</p>
              <p>{{ scope.row.format.sendFrom }}</p>
              <p>{{ scope.row.format.sendAt }}</p>
            </template>
          </el-table-column>
          <!-- 聊天内容 -->
          <el-table-column align="center" :label="$t('message.chatContent')" min-width="300">
            <template slot-scope="scope">
              <div v-html="scope.row.format.message_content"
                @dblclick="getComplainMessageContext(scope.row.message_id, scope.row.format.chat_type, scope.row.message_content)"
                class="text-left">
              </div>
            </template>
          </el-table-column>
          <!-- 状态-->
          <el-table-column align="center" :label="$t('message.status')" width="100">
            <template slot-scope="scope">
              {{ scope.row.format.status_name }}
            </template>
          </el-table-column>
          <!-- 类型-->
          <el-table-column align="center" :label="$t('message.type')" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.format.type_name == '确认为投诉' ? 'primary' : 'success'" size="small"> {{
                scope.row.format.type_name
              }}</el-tag>
            </template>
          </el-table-column>
          <!-- 是否纳入考核-->
          <el-table-column align="center" :label="$t('message.isIncludedInAssessment')" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.performance_status == '1' ? 'success' : 'danger'" size="small"
                v-if="scope.row.performance_status"> {{
                  scope.row.performance_status == '1' ? $t('message.are') : $t('message.no')
                }}</el-tag>
            </template>
          </el-table-column>
          <!-- 投诉类型-->
          <el-table-column align="center" :label="$t('message.complaintType')" width="100">
            <template slot-scope="scope">
              {{ scope.row.complaint_type_name }}
            </template>
          </el-table-column>
          <!-- 匹配/处理/审核/确认 -->
          <el-table-column align="center" :label="$t('message.fourSteps')" prop="send_realname" width="225">
            <template slot-scope="scope">
              <p>
                匹配:
                {{ scope.row.created_at }}
              </p>
              <p>
                业务处理:
                {{ scope.row.y_deal_at }}
              </p>
              <p>
                日本确认:
                {{ scope.row.japan_deal_at }}
              </p>
              <p>
                部长审核:
                {{ scope.row.depart_deal_at }}
              </p>
              <p>
                最终复审:
                {{ scope.row.review_at }}
              </p>
              <p>
                处理完成:
                {{ scope.row.confirm_at }}
              </p>
            </template>
          </el-table-column>
          <!-- 处理截图 -->
          <el-table-column align="center" :label="$t('message.ProcessScreenshots')">
            <template slot-scope="scope">
              <el-image style="width: 60px; height: 60px;margin-right: 10px;" :src="item" :preview-src-list="[item]"
                v-for="(item, index) in scope.row.deal_images" :key="index">
              </el-image>
            </template>
          </el-table-column>

          <!-- 处理思路 -->
          <el-table-column align="center" :label="$t('message.handlingIdeas')" width="200">
            <template slot-scope="scope">
              <el-input type="textarea" v-model="scope.row.remark" disabled></el-input>
            </template>
          </el-table-column>
          <!-- 日本审核备注 -->
          <el-table-column align="center" :label="$t('message.japanReviewRemarks')" width="200">
            <template slot-scope=" scope">
              <el-image style="width: 60px; height: 60px;margin-right: 10px;" :src="item" :preview-src-list="[item]"
                v-for="(item, index) in scope.row.japan_images" :key="index">
              </el-image>
              <el-input type="textarea" v-model="scope.row.japan_remark" disabled></el-input>
            </template>
          </el-table-column>

          <!-- 评分 -->
          <el-table-column align="center" :label="$t('message.score')" width="200">
            <template slot-scope=" scope" v-if="scope.row.format.type_name == '确认为投诉'">
              <!-- *问题严重程度： -->
              <div class="row">
                {{ $t('message.SeveritProblem') }} : <span><el-rate v-model="scope.row.score_severity"
                    disabled></el-rate></span>
              </div>
              <!-- **客户重要程度 -->
              <div class="row">
                {{ $t('message.CustomeImportance') }} : <span><el-rate v-model="scope.row.score_priority"
                    disabled></el-rate></span>
              </div>
              <!-- 业务解决问题的情况 -->
              <div class="row">
                {{ $t('message.BusinessSituation') }} : <span><el-rate v-model="scope.row.score_resolution"
                    disabled></el-rate></span>
              </div>
              <!-- *发现问题-解决问题时长： -->
              <div class="row">
                {{ $t('message.ProblemSolvingDuration') }} : <span><el-rate v-model="scope.row.score_timeliness"
                    disabled></el-rate>
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- 部长确认-->
          <el-table-column align="center" :label="$t('message.ministerConfirmation')" width="200">
            <template slot-scope="scope" v-if="scope.row.status != 20">
              <el-input type="textarea" v-model="scope.row.depart_remark" disabled></el-input>
            </template>
          </el-table-column>
          <!-- 确认截图 -->
          <el-table-column align="center" :label="$t('message.confirmScreenshot')">
            <template slot-scope="scope">
              <el-image style="width: 60px; height: 60px;margin-right: 10px;" :src="item" :preview-src-list="[item]"
                v-for="(item, index) in scope.row.depart_images" :key="index">
              </el-image>
            </template>
          </el-table-column>
          <!-- 复审原因 -->
          <el-table-column align="center" :label="$t('message.reReviewReason')" width="200">
            <template slot-scope=" scope">
              <el-input type="textarea" v-model="scope.row.review_reason" disabled></el-input>
            </template>
          </el-table-column>
          <!-- 补充截图 -->
          <el-table-column align="center" :label="$t('message.supplementalScreenshots')">
            <template slot-scope="scope">
              <el-image style="width: 60px; height: 60px;margin-right: 10px;" :src="item" :preview-src-list="[item]"
                v-for="(item, index) in scope.row.depart_images" :key="index">
              </el-image>
            </template>
          </el-table-column>
          <!-- 评分状态-->
          <el-table-column align="center" :label="$t('message.ratingStatus')" width="100" fixed="right">
            <template slot-scope="scope" v-if="scope.row.format.type_name == '确认为投诉'">
              <span v-if="scope.row.score_status == 1">待评分</span>
              <span v-if="scope.row.score_status == 2">已评分</span>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <!-- 其他列表 -->
      <div class="table" v-else>
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" border v-if="isShow"
          :max-height="tableautoheight" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="45" align="center"
            v-if="datas.statusName == '待部长确认' || datas.statusName == '最终复核'">
          </el-table-column>
          <!-- 客户信息 -->
          <el-table-column align="center" :label="$t('message.userInfo')" prop="send_realname" width="120">
            <template slot-scope="scope">
              <p>ID:{{ scope.row.format.user_id }}</p>
              <p>{{ scope.row.format.user_realname }}</p>
              <p>
                <attributeName :name="scope.row.format.user_attribute" />
              </p>
            </template>
          </el-table-column>
          <!-- 对应人员 -->
          <el-table-column align="center" :label="$t('message.correspondingPersonnel')" prop="send_realname"
            width="120">
            <template slot-scope="scope">
              <!-- 业务：XXX -->
              <p> {{ $t('message.business') }}:
                {{ scope.row.format.y_realname }}</p>
              <!-- 采购：XXX-->
              <p> {{ $t('message.purchase') }}:{{ scope.row.format.g_realname }}</p>
              <!-- 配货：XXX -->
              <p> {{ $t('message.distribution') }}:{{ scope.row.format.p_realname }}</p>
            </template>
          </el-table-column>
          <!-- 发送对象 -->
          <el-table-column align="center" prop="send_realname" width="160">
            <template slot-scope="scope">
              <p v-if="scope.row.format.chat_type == 'CW'"> <img src="@/assets/icon/chatword.png" alt=""
                  style="width: 40px; vertical-align: middle;">CHATWORK</p>
              <p v-else> <img src="@/assets/icon/Rakuchat.png" alt=""
                  style="width: 40px; vertical-align: middle;">RAKUCHAT</p>
              <p>{{ scope.row.format.sendFrom }}</p>
              <p>{{ scope.row.format.sendAt }}</p>
            </template>
          </el-table-column>

          <!-- 聊天内容 -->
          <el-table-column align="center" :label="$t('message.chatContent')" min-width="300">
            <template slot-scope="scope">
              <div v-html="scope.row.format.message_content"
                @dblclick="getComplainMessageContext(scope.row.message_id, scope.row.format.chat_type, scope.row.message_content)"
                class="text-left">
              </div>
            </template>
          </el-table-column>
          <!-- 匹配/处理/审核/确认 -->
          <el-table-column align="center" :label="$t('message.fourSteps')" prop="send_realname" width="225"
            v-if="datas.statusName == '已完成' && !datas.score_status">
            <template slot-scope="scope">
              <p>
                匹配:
                {{ scope.row.created_at }}
              </p>
              <p>
                业务处理:
                {{ scope.row.y_deal_at }}
              </p>
              <p>
                日本确认:
                {{ scope.row.japan_deal_at }}
              </p>
              <p>
                部长审核:
                {{ scope.row.depart_deal_at }}
              </p>
              <p>
                最终复审:
                {{ scope.row.review_at }}
              </p>
              <p>
                处理完成:
                {{ scope.row.confirm_at }}
              </p>
            </template>
          </el-table-column>
          <!-- 处理截图 -->
          <el-table-column align="center" :label="$t('message.ProcessScreenshots')" v-if="datas.statusName != '待内部处理'">
            <template slot-scope="scope">
              <el-image style="width: 60px; height: 60px;margin-right: 10px;" :src="item" :preview-src-list="[item]"
                v-for="(item, index) in scope.row.deal_images" :key="index">
              </el-image>
            </template>
          </el-table-column>
          <!-- 状态-->
          <!-- <el-table-column align="center" :label="$t('message.status')" width="100" v-if="datas.statusName == '已完成'">
            <template slot-scope="scope">
              {{ $t('message.Processed') }}
            </template>
          </el-table-column> -->
          <!-- 处理思路 -->
          <el-table-column align="center" :label="$t('message.handlingIdeas')" width="200">
            <template slot-scope="scope">
              <el-input type="textarea" v-model="scope.row.remark"
                @blur="dealUpdateRemark(scope.row, scope.row.format.chat_type)"
                :disabled="datas.statusName != '待内部处理'"></el-input>
            </template>
          </el-table-column>
          <!-- 日本审核备注 -->
          <el-table-column align="center" :label="$t('message.japanReviewRemarks')" width="200"
            v-if="datas.statusName != '待内部处理'">
            <template slot-scope=" scope">
              <el-image style="width: 60px; height: 60px;margin-right: 10px;" :src="item" :preview-src-list="[item]"
                v-for="(item, index) in scope.row.japan_images" :key="index">
              </el-image>
              <el-input type="textarea" v-model="scope.row.japan_remark"
                @blur="dealUpdateJapanRemark(scope.row, scope.row.format.chat_type)"
                :disabled="datas.statusName != '待日本审核' || !isAuth(552)"></el-input>
            </template>
          </el-table-column>
          <!-- 部长确认-->
          <el-table-column align="center" :label="$t('message.ministerConfirmation')" width="200"
            v-if="datas.statusName != '待内部处理' && datas.statusName != '待日本审核' && datas.score_status != 1">
            <template slot-scope="scope" v-if="scope.row.status != 20">

              <el-input type="textarea" v-model="scope.row.depart_remark"
                @blur="updateDepartRemarkV4(scope.row, scope.row.format.chat_type)"
                :disabled="datas.statusName != '待部长确认' || !isAuth(576)"></el-input>
            </template>
          </el-table-column>
          <!-- 评分 -->
          <el-table-column align="center" :label="$t('message.score')" width="200"
            v-if="datas.statusName == '已完成' && datas.score_status != 1">
            <template slot-scope=" scope" v-if="scope.row.format.type_name == '确认为投诉'">
              <!-- *问题严重程度： -->
              <div class="row">
                {{ $t('message.SeveritProblem') }} : <span><el-rate v-model="scope.row.score_severity"
                    disabled></el-rate></span>
              </div>
              <!-- **客户重要程度 -->
              <div class="row">
                {{ $t('message.CustomeImportance') }} : <span><el-rate v-model="scope.row.score_priority"
                    disabled></el-rate></span>
              </div>
              <!-- 业务解决问题的情况 -->
              <div class="row">
                {{ $t('message.BusinessSituation') }} : <span><el-rate v-model="scope.row.score_resolution"
                    disabled></el-rate></span>
              </div>
              <!-- *发现问题-解决问题时长： -->
              <div class="row">
                {{ $t('message.ProblemSolvingDuration') }} : <span><el-rate v-model="scope.row.score_timeliness"
                    disabled></el-rate>
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- 复审原因 -->
          <el-table-column align="center" :label="$t('message.reReviewReason')" width="200"
            v-if="datas.statusName == '最终复核' || datas.statusName == '已完成' || datas.score_status">
            <template slot-scope=" scope">
              <el-input type="textarea" v-model="scope.row.review_reason" disabled></el-input>
            </template>
          </el-table-column>
          <!-- 补充截图 -->
          <el-table-column align="center" :label="$t('message.supplementalScreenshots')"
            v-if="datas.statusName == '最终复核' || datas.statusName == '已完成' || datas.score_status">
            <template slot-scope="scope">
              <el-image style="width: 60px; height: 60px;margin-right: 10px;" :src="item" :preview-src-list="[item]"
                v-for="(item, index) in scope.row.depart_images" :key="index">
              </el-image>
            </template>
          </el-table-column>
          <!-- 类型-->
          <el-table-column align="center" :label="$t('message.type')" width="100" v-if="datas.statusName != '待内部处理'">
            <template slot-scope="scope">
              <el-tag :type="scope.row.format.type_name == '确认为投诉' ? 'primary' : 'success'" size="small"> {{
                scope.row.format.type_name
              }}</el-tag>
            </template>
          </el-table-column>
          <!-- 是否纳入考核-->
          <el-table-column align="center" :label="$t('message.isIncludedInAssessment')" width="100"
            v-if="datas.statusName != '待内部处理'">
            <template slot-scope="scope">
              <el-tag :type="scope.row.performance_status == '1' ? 'success' : 'danger'" size="small"
                v-if="scope.row.performance_status"> {{
                  scope.row.performance_status == '1' ? $t('message.are') : $t('message.no')
                }}</el-tag>
            </template>
          </el-table-column>
          <!-- 投诉类型-->
          <el-table-column align="center" :label="$t('message.complaintType')" width="100"
            v-if="datas.statusName != '待内部处理'">
            <template slot-scope="scope">
              {{ scope.row.complaint_type_name }}
            </template>
          </el-table-column>
          <!-- 评分状态-->
          <el-table-column align="center" :label="$t('message.ratingStatus')" width="100"
            v-if="datas.statusName == '已完成' && !datas.score_status" fixed="right">
            <template slot-scope="scope" v-if="scope.row.format.type_name == '确认为投诉'">
              <span v-if="scope.row.score_status == 1">待评分</span>
              <span v-if="scope.row.score_status == 2">已评分</span>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')" width="100"
            v-if="datas.statusName != '已完成' || datas.score_status == 1" fixed="right">
            <template slot-scope="scope">
              <!--待内部处理  -->
              <div v-if="datas.statusName == '待内部处理'">
                <!-- 确认为投诉 -->
                <p style="margin-bottom: 10px;">
                  <el-button type="primary" size="mini" @click="complainConfirm(scope.row, scope.row.format.chat_type)">
                    {{ $t('message.internalConfirmation') }}
                  </el-button>
                </p>
              </div>
              <!--待部长确认  -->
              <div v-if="datas.statusName == '待部长确认' && isAuth(576)">
                <p style="margin-bottom: 10px;">
                  <!-- 确认无误 -->
                  <el-button type="primary" size="mini" @click="ImmediateReview(scope.row, scope.row.format.chat_type)">
                    {{ $t('message.ConfirmedWithoutError') }}
                  </el-button>
                </p>
                <!-- 提出复审 -->
                <el-button type="success" size="mini" @click="requestReReview(scope.row, scope.row.format.chat_type)">
                  {{ $t('message.requestReReview') }}
                </el-button>

              </div>
              <!--待日本审核  -->
              <div v-if="datas.statusName == '待日本审核' && isAuth(552)">
                <!-- 审核 -->
                <el-button type="primary" size="mini" @click="notarize(scope.row, scope.row.format.chat_type)">
                  {{ $t('message.examine') }}
                </el-button>
              </div>
              <!--最终复核  -->
              <div v-if="datas.statusName == '最终复核' && isAuth(581)">
                <!-- 开始复审 -->
                <el-button type="primary" size="mini" @click="startReReview(scope.row, scope.row.format.chat_type)">
                  {{ $t('message.startReReview') }}
                </el-button>
              </div>
              <!-- 评分 -->
              <div v-if="datas.statusName == '已完成' && datas.score_status == 1 && scope.row.format.type_name == '确认为投诉'">
                <!-- 审核 -->
                <el-button type="primary" size="mini" @click="addScorev4(scope.row, scope.row.format.chat_type)"
                  v-if="isAuth(652)">
                  {{ $t('message.score') }}
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[100, 200, 500,]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 聊天记录 -->
    <chatHistory v-else-if="type == 'chatHistory'" :complainDetail="complainDetail" />
    <!-- 投诉列表 -->
    <!-- <complainList v-else-if="type == 'complainList'" :complainDetail="complainDetail" /> -->
    <!-- 上下50条 -->
    <upAndDown ref="upAndDown" />
    <!-- 客户投诉处理 -->
    <toWaitDepart ref="toWaitDepart" />
    <!-- 非投诉 -->
    <toCancel ref="toCancel" />
    <!-- 部长确认回复 -->
    <ministerConfirmsReply ref="ministerConfirmsReply" />
    <!-- 日本确认 -->
    <pendingJapanReview ref="pendingJapanReview" />
    <!-- 待部长确认-提交到下一步 -->
    <toDepartReConfirmed ref="toDepartReConfirmed" />
    <!-- 提出复核 -->
    <requestReReview ref="requestReReview" />
    <!--复核  -->
    <reReview ref="reReview" />
    <!-- 新增评分 -->
    <addScore ref="addScore" />
  </div>
</template>
<script>
import chatHistory from './components/chatHistory.vue'
import complainList from './components/complainList.vue'
import upAndDown from './components/upAndDown'
import toWaitDepart from './components/toWaitDepart'
import toCancel from './components/toCancel'
import ministerConfirmsReply from './components/ministerConfirmsReply'
import pendingJapanReview from './components/pendingJapanReview'
import toDepartReConfirmed from './components/toDepartReConfirmed'
import requestReReview from './components/requestReReview'
import reReview from './components/reReview'
import addScore from './components/addScore'
export default {
  components: {
    chatHistory,
    complainList,
    upAndDown,
    toWaitDepart,
    toCancel,
    ministerConfirmsReply,
    pendingJapanReview,
    toDepartReConfirmed,
    requestReReview,
    reReview,
    addScore
  },
  data() {
    return {
      tableautoheight: window.innerHeight > 700 ? window.innerHeight - 200 : 800,
      isShow: true,
      complainDetail: { type: '', id: 0 },//投诉详情
      type: 'chatSummary',
      datas: {
        user_id: '',
        chatType: '',
        statusName: '待内部处理',
        page: 1,
        pageSize: 100,
      },
      total: 0,
      chatType: [
        {
          value: 'CW',
          label: 'CHATWORK'
        },
        {
          value: 'RC',
          label: 'RAKUCHAT'
        },
      ],
      tableData: [],
      tabsNum: [{}, {}, {}, {}, {}, {}],
      complaintType: [],//投诉类型
      multipleSelection: [],
    };
  },
  computed: {
    option() {
      return [
        { value: '35', label: this.$t('message.confirmedComplaint') },//确认投诉
        { value: '30', label: this.$t('message.nonComplaint') },//非投诉
      ]
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
  },

  created() {
    let query = this.$route.query
    if (query.chatType) {
      this.datas.chatType = query.chatType
    }
      if (query.statusName) {
      this.datas.statusName = query.statusName
    }


    if (query.isComplain == 1) {
      this.datas.statusName = '待内部处理'
    } else if (query.isComplain == 2) {
      this.datas.statusName = '待日本审核'
    } else if (query.isComplain == 3) {
      this.datas.statusName = '待部长确认'
    } else if (query.isComplain == 4) {
      this.datas.statusName = '最终复核'
    }

    this.clientListV4()
    this.$api.siteConfiguration.complaintType().then(res => {
      this.complaintType = res.data
    })
    this.clientListV4TabNum()
  },
  methods: {
    clientListV4() {
      this.isShow = false
      this.multipleSelection = []
      this.$api.siteConfiguration.clientListV4(this.datas).then(res => {
        res.data.data.forEach(item => {
          item.score_severity = item.score_severity - 0
          item.score_priority = item.score_priority - 0
          item.score_resolution = item.score_resolution - 0
          item.score_timeliness = item.score_timeliness - 0
          item.message_content = JSON.parse(JSON.stringify(item.format.message_content))
          item.hitKeywords.forEach(items => {
            item.format.message_content = item.format.message_content.replaceAll(items, `<span style='color:red'>${items}</span>`)
          })
        })
        this.tableData = res.data.data
        this.total = res.data.total
        this.isShow = true
      })
    },
    // tab数量统计
    clientListV4TabNum() {
      this.$api.siteConfiguration.clientListV4TabNum().then(res => {
        this.tabsNum = res.data
      })
    },
    search() {
      this.datas.page = 1
      this.clientListV4()
    },
    // 筛选评分
    setScoreStatus(type) {
      this.datas.score_status = type
      this.search()
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.clientListV4()
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.clientListV4()
    },
    //查看历史消息
    lookChatHistory(id, type) {
      this.complainDetail = {
        id,
        type,
      }
      this.type = 'chatHistory'
      console.log(this.complainDetail);
    },
    // 选中的
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 处理编辑备注
    dealUpdateRemark(row, chat_type) {
      let datas = {
        ids: [row.id],
        type: chat_type,
        content: row.remark,
      }
      this.$api.siteConfiguration.dealUpdateRemark(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 待部长确认-实时修改部长留言
    dealUpdateDepartRemark(row, chat_type) {
      let datas = {
        ids: [row.id],
        type: chat_type,
        content: row.depart_reconfirm_remark,
      }
      this.$api.siteConfiguration.dealUpdateDepartRemark(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 实时待日本审核 
    dealUpdateJapanRemark(row, chat_type) {
      let datas = {
        ids: [row.id],
        type: chat_type,
        content: row.japan_remark,
      }
      this.$api.siteConfiguration.updateJapanRemarkV4(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 最终复核-实时修改待部长确认备注
    updateDepartRemarkV4(row, chat_type) {
      let datas = {
        ids: [row.id],
        type: chat_type,
        content: row.depart_remark,
      }
      this.$api.siteConfiguration.updateDepartRemarkV4(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    //  部長审核
    ImmediateReview(item, chat_type) {
      this.$refs.ministerConfirmsReply.datas = {
        id: [item.id],
        type: chat_type,
        content: item.depart_remark,
        depart_images: [],
        performance_status: item.performance_status,
      }
      this.$refs.ministerConfirmsReply.fileList = []
      this.$refs.ministerConfirmsReply.dialogVisible = true
    },
    //  提出复核
    requestReReview(item, chat_type) {
      this.$refs.requestReReview.datas = {
        id: item.id,
        type: chat_type,
        review_reason: '',
        depart_images: [],
        performance_status: 2,
      }
      this.$refs.requestReReview.fileList = []
      this.$refs.requestReReview.dialogVisible = true
    },
    // RC聊天上下50条上下文
    getComplainMessageContext(id, chat_type, text) {
      if (chat_type == 'CW') {
        this.$api.siteConfiguration.getCWComplainMessageContext({ id }).then(res => {
          this.$refs.upAndDown.upAndDownList = res.data
          this.$refs.upAndDown.dialogVisible = true
          this.$refs.upAndDown.type = chat_type
          this.$refs.upAndDown.text = text
        })
      } else {
        this.$api.siteConfiguration.getRCComplainMessageContext({ id }).then(res => {
          this.$refs.upAndDown.upAndDownList = res.data
          this.$refs.upAndDown.dialogVisible = true
          this.$refs.upAndDown.type = chat_type
          this.$refs.upAndDown.text = text
        })
      }
    },
    //待内部处理
    complainConfirm(item, chat_type) {
      this.$refs.toWaitDepart.datas = {
        id: [item.id],
        type: chat_type,
        content: item.remark,
        deal_images: [],
        complaint_type: '',
        is_complain: 1,
        performance_status: 1,
      }
      this.$refs.toWaitDepart.fileList = []
      this.$refs.toWaitDepart.dialogVisible = true
    },
    // 日本审核
    notarize(item, chat_type) {
      this.$refs.pendingJapanReview.datas = {
        id: item.id,
        type: chat_type,
        content: item.japan_remark,
        is_complain: item.format.type_name == '确认为投诉' ? 1 : 0,
        complaint_type: item.complaint_type,
        performance_status: item.performance_status,
        japan_images: []
      }
      this.$refs.pendingJapanReview.fileList = []
      this.$refs.pendingJapanReview.dialogVisible = true
    },
    // 部长确认回复
    toDepartReConfirmed(item, chat_type) {
      this.$refs.toDepartReConfirmed.datas = {
        id: [item.id],
        type: chat_type,
        content: item.depart_reconfirm_remark,
        performance_status: item.performance_status,

      }
      this.$refs.toDepartReConfirmed.dialogVisible = true
    },
    //开始复审
    startReReview(item, chat_type) {
      this.$refs.reReview.datas = {
        id: item.id,
        type: chat_type,
        review_remark: '',
        is_complain: item.format.type_name == '确认为投诉' ? 1 : 0,
        complaint_type: item.complaint_type,
        performance_status: item.performance_status,
      }
      this.$refs.reReview.dialogVisible = true
    },
    // 新增评分
    addScorev4(item, chat_type) {
      this.$refs.addScore.datas = {
        id: item.id,
        type: chat_type,
        score_severity: 0,
        score_priority: 0,
        score_resolution: 0,
        score_timeliness: 0,
      }
      this.$refs.addScore.dialogVisible = true
    },
    //批量审核
    batchReviewProcess() {
      if (this.multipleSelection == false) return this.$message.error('请选择要操作的列表')
      let datas = {
        id: [],
        type: this.multipleSelection[0].format.chat_type,
        content: this.multipleSelection[0].depart_remark,
        depart_images: [],
        performance_status: this.multipleSelection[0].performance_status,
      }
      this.multipleSelection.forEach(item => {
        datas.id.push(item.id)
      })
      console.log(datas);
      this.$refs.ministerConfirmsReply.datas = datas
      this.$refs.ministerConfirmsReply.fileList = []
      this.$refs.ministerConfirmsReply.dialogVisible = true
    },
    // 批量确认
    BatchConfirmation() {
      if (this.multipleSelection == false) return this.$message.error('请选择要操作的列表')
      let datas = {
        id: [],
        type: this.multipleSelection[0].format.chat_type,
        content: this.multipleSelection[0].depart_reconfirm_remark,
        is_complain: '1',
        performance_status: this.multipleSelection[0].performance_status,
      }
      this.multipleSelection.forEach(item => {
        datas.id.push(item.id)
      })
      this.$refs.toDepartReConfirmed.datas = datas
      this.$refs.toDepartReConfirmed.dialogVisible = true
    },
  }
}
</script>
<style lang='scss' scoped>
.tabs {
  position: relative;

  .btn {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.search {
  display: flex;
  margin-bottom: 24px;
  position: relative;

  .btn {
    position: absolute;
    right: 0;
    top: 0;
  }

  .item {
    margin-right: 24px;
  }
}

.template {
  width: 100%;


  .item {
    display: flex;
    cursor: pointer;

    .item-box {
      display: flex;
      line-height: 54px;

      .type {
        display: flex;

        .type-item {
          margin-left: 20px;

          span {
            color: #B4272D;
            font-size: 18px;
            font-weight: bold;

          }
        }
      }
    }

    .logo {
      margin-right: 30px;
      width: 120px;

      img {
        vertical-align: middle;
        margin-right: 5px;
        width: 31px;
        cursor: pointer;

      }

      margin: 12px;
    }

    .complain {
      margin-left: 50px;

      span {
        margin-right: 20px;

        &:nth-last-child(1) {
          margin: 0;
        }
      }

      b {
        color: #B4272D;
        font-size: 18px;
        font-weight: bold;


      }
    }
  }
}

/deep/ .el-textarea__inner {
  padding: 5px;
  min-height: 180px !important;
  resize: none;
}
</style>